// Certificates
export const MANAGE_CERT_IMPORT_PFX = "0";
export const MANAGE_CERT_GENERATE = '1';
export const MANAGE_CERT_IMPORT_PEM = '2';
export const MANAGE_CERT_REVOKE = '3';
